<h2 mat-dialog-title [class.popia-title]="requireLegalGround">{{ title }}</h2>

<mat-dialog-content [class.popia-content]="requireLegalGround">
  <p
    *ngFor="let paragraph of body; let i = index"
    class="body-text"
    [class.confirmation-text]="!requireLegalGround && i > 0"
  >
    {{ paragraph }}
  </p>

  <ng-container *ngIf="requireLegalGround">
    <p class="grounds-prompt">On what legal ground are you receiving this information?</p>

    <mat-radio-group class="legal-grounds-list" [(ngModel)]="selectedLegalGround" name="popiaLegalGround">
      <mat-radio-button
        *ngFor="let option of legalGroundOptions"
        [value]="option.code"
        color="primary"
        class="ground-item"
      >
        {{ option.label }}
      </mat-radio-button>
    </mat-radio-group>

    <p class="confirmation-text">
      By continuing, I confirm that I lawfully hold the identity number I have submitted, that the ground selected
      above applies to this search, and that I will use the result only for that ground — not for direct marketing,
      and not for supply to any third party outside the matter. I understand this applies each time I access or
      process personal information on this system.
    </p>

    <p class="audit-note">
      This search is recorded against my user account, the ground selected, and the time it was run.
    </p>
  </ng-container>

  <p class="legal-links" *ngIf="showLegalLinks">
    <a [href]="termsUrl" target="_blank" rel="noopener noreferrer" (click)="openExternalLink($event, termsUrl)">Terms of Use</a>
    <span aria-hidden="true"> · </span>
    <a [href]="privacyUrl" target="_blank" rel="noopener noreferrer" (click)="openExternalLink($event, privacyUrl)">Privacy &amp; POPIA Notice</a>
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end" [class.popia-actions]="requireLegalGround">
  <button mat-button (click)="reject()" color="warn">{{ rejectLabel }}</button>
  <button mat-raised-button (click)="accept()" color="primary" [disabled]="!canAccept">
    {{ acceptLabel }}
  </button>
</mat-dialog-actions>
